import React, { Component } from "react";
import { API_URL } from "../../config";
// import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import {
  Button,
  // TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Link,
  Container,
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
  OutlinedInput,
  // InputLabel
} from "@material-ui/core";
import "./login.css";
import TsiLogo from "../assets/logo.png";
// import CCTV from "../assets/loginbg.jpg";
// import ForgotPassword from "./ForgotPassword";
import { fetchMethod } from "../../FetchMethod";
import {
  // login,
  // getData,
  UserIdMatch,
  // UserIdRole,
  // ValidUser,
  // UserData
} from "./LoginQueries";
import swal from "sweetalert";
import App from "../../App";
import {
  VisibilityOutlined,
  VisibilityOffOutlined,
  // ContactSupportOutlined,
  // Warning
} from "@material-ui/icons";
import Sidebar from "../SideBar/Sidebar";

class Login extends Component {
  constructor(props) {
    super(props);

    const token = localStorage.getItem("token");
    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }

    this.state = {
      email: "",
      password: "",
      userData: undefined,
      showPassword: false,
      Id: null,
      role: undefined,
      forgot: false,
      Validate: undefined,
      customerId: undefined,
      loading: false,
      errors: { email: "" },
      user: null
    };
  }
  componentDidMount() {
    this.validateId();
  }

  validateId = () => {
    let email = localStorage.getItem("email");

    this.idVerification();
    if (email === undefined || email === null || email === "") {
      if (
        this.state.Id === null ||
        this.state.Id === "" ||
        this.state.Id == undefined
      ) {
        if (localStorage.getItem("id") !== this.state.Id) {
          localStorage.removeItem("token");
        }
      }
    }
  };

  idVerification = () => {
    let email = localStorage.getItem("email");
 
    fetchMethod(UserIdMatch(JSON.stringify(email)))
      .then(res => res.json())
      .then(res => {
        res.data.allUsersdata.Usersdata[0].id !== undefined
          ? this.setState({ Id: res.data.allUsersdata.Usersdata[0].id }, () => {
              this.props.UserExist(this.state.Id);
            })
          : this.setState({ loading: true });
      })
      .catch(e => e);

    if (this.state.Id === undefined) {
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("email");
    }
  };

  handleChange = e => {
    if (e.target.id === "email") {
      this.setState({ email: e.target.value.trim() }, () => {
        this.idVerification();
      });
    }

    if (e.target.id === "password") {
      this.setState({ password: e.target.value });
    }
  };
  validateForm = email => {
    const { errors } = this.state;
    const validEmailRegex = RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    errors.email = validEmailRegex.test(email.trim())
      ? ""
      : "Email is not valid!";
    this.setState({ errors });
    return this.state.errors.email === "Email is not valid!" ? false : true;
  };
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  onSubmit = e => {
    e.preventDefault();
    if (this.state.email === "" || this.state.password === "") {
      swal({
        icon: "warning",
        title: "Please enter Email-ID and Password"
      });
      return;
    } else {
      if (this.validateForm(this.state.email)) {
        fetch(`${API_URL}/api/Usersdata/login`, {
          method: "POST",
          mode: "cors",
          body: JSON.stringify(
          
            {
              email: this.state.email,
              password: this.state.password
            }
          ),
          headers: {
            "Content-type": "application/json"
          }
        })
        
          .then(res => res.json())
          .then(res => {
            if (
              res.userId === undefined &&
              res.error.name === "Error"

            ) {
              this.props.UserExist(this.state.user);
              swal({
                icon: "warning",
                title: "Incorrect credentials"
              });
            } else if (
              res === null &&
              res.userId !== null

            ) {
              this.props.UserExist(this.state.user);
              swal({
                icon: "warning",
                title: "The Email-ID or Password you entered is incorrect"
              });
            } else {
           
              fetch(
                `${API_URL}/api/Usersdata?filter={"where":{"email": "${localStorage.getItem(
                  "email"
                )}","status":1}}`,
                {
                  headers: {
                    "Content-type": "application/json"
                  }
                }
              )
                .then(res => res.json())
                .then(response => {
                  if (response.length > 0) {
                    localStorage.setItem(
                      "name",
                      response[0].firstName + " " + response[0].lastName
                    );
                    localStorage.setItem(
                      "profileImage",
                      response[0].profileImage
                    );
                    localStorage.setItem("role", response[0].role);
                    localStorage.setItem("customer", response[0].customerid);

                    this.setState(
                      {
                        userData: res
                      },
                      () => {
                        localStorage.setItem("id", this.state.userData.userId);
                        localStorage.setItem("token", this.state.userData.id);
                        localStorage.setItem("abmId", String(this.state.userData.userId)+ String(response[0].abm));
                        this.fetchCustomer(this.state.userData.userId);
                      }
                    );
                  } else if (
                   
                    (localStorage.removeItem("token"),
                    localStorage.removeItem("id"),
                    localStorage.removeItem("userId"),
                    localStorage.removeItem("role"),
                    localStorage.removeItem("customer"),
                    localStorage.removeItem("email"),
                    localStorage.removeItem("name"),
                    localStorage.removeItem("profileImage"),
                    localStorage.removeItem("abmId"),
                    response.length === 0)
                  ) {
                    swal(
                      "Your account is inactive please connect with the admin.",
                      {
                        icon: "error"
                      }
                    );
                  } else {
                    this.setState({ loading: true });
                  }
                });
            }
          })
          .catch(e => {
            console.log(e);
            swal({ title: "Unable to connect to server", icon: "warning" });
          });
      }
    }
    this.forceUpdate();
  };
  fetchCustomer = id => {
    var cc = `${API_URL}/api/Usersdata/Usersdata/${id}/customerIbfk5rel`;

    //     "https://devupi.xseller8.org/api/Usersdata/Usersdata/225/customerIbfk5rel"
    // fetch(`https://devupi.xseller8.org/api/Usersdata/225/customerIbfk5rel`, {
    fetch(`${API_URL}/api/Usersdata/${id}/customerIbfk5rel`, {
      headers: {
        "Content-type": "application/json"
      }
    })
      .then(res => res.json())
      .then(res => {
        localStorage.setItem("companyName", res.company);


        window.location = "/";
      })
      .catch(e => e);
    this.forceUpdate();
  };
  
  render() {
    const storageToken = localStorage.getItem("token");
    if (storageToken !== null && storageToken !== "undefined") {
      return <Route component={App} />;
    }

    localStorage.setItem("email", this.state.email);
    return (
      <div
        className="login loginFormContainer"
      
        style={{
          background:
            "transparent linear-gradient(119deg, #007D96 0%, #1898BE 69%, #2BADDD 100%) 0% 0% no-repeat padding-box"
          
        }}
       
      >
      
        <Container className="container" maxWidth="xs">
          <div>
            <form className="form loginForm" onSubmit={this.onSubmit}>
           
              <div className="logoBox">
                <img src={TsiLogo} />
              </div>

              <Typography
                variant="body2"
                color="inherit"
                align="center"
                className="subHead"
              >
                A common platform to manage all LinkedIn <br /> campaign
                solutions!
              </Typography>

              <FormControl variant="standard" className="inputFIeld">
                <label htmlFor="bootstrap-input">Email address</label>
                
                <OutlinedInput
                  value={this.state.email}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  placeholder="e.g. john.doe@gmail.com"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={this.handleChange}
                />
              </FormControl>

              <FormControl variant="standard" className="inputFIeld">
                <label htmlFor="bootstrap-input">Password</label>
                
                <OutlinedInput
                  id="password"
                  placeholder="*****************"
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.password}
                  onChange={this.handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                        className={"PasswordVisibility"}
                      >
                        {this.state.showPassword ? (
                          <VisibilityOutlined />
                        ) : (
                          <VisibilityOffOutlined />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>

              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me!"
                style={{
                  font: "normal normal normal 13px/20px Poppins"
                }}
                className="rememberCheck"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ backgroundColor: "#273c75" }}
                className="signInBtn"
              >
                Sign In
              </Button>
              <Grid container className="forgotPassLink">
                <Grid item xs>
                  <Link
                    href="/forgotpassword"
                    style={{
                      cursor: "pointer",
                      color: "#ff2c00",
                      textDecoration: "underline",

                      font: "normal normal normal 14px / 21px Poppins"
                    }}
                    variant="body2"
                  >
                    Forgot Password?
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
        </Container>
      </div>
    );
  }

  handleMouseDownPassword = e => {
    e.preventDefault();
  };
}
const mapDispatchToProps = dispatch => {
  return {
    UserExist: id => {
      dispatch({ type: "Email_Verification", payload: id });
    }
  };
};

const mapStateToProps = state => {
  return { emailVerification: state.emailVerification };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
